const { activeAdmins } = require('../constants/consentAdmins');
const { activePermissions } = require('../constants/consentPermissions');
const { CONSENT_STORAGE_NAME } = require('../constants/consentStorageName');
const { getCheckedConsent } = require('../utils/getCheckedConsent');

const runConsentEvent = function() {
  const consent = getCheckedConsent(activeAdmins, activePermissions);
  window.dataLayer.push(
      Object.assign(
          {
            event: 'consent_update'
          },
          consent
      )
  );

  // Save consent state
  window.localStorage.setItem(CONSENT_STORAGE_NAME, JSON.stringify(consent));

  setTimeout(function () {
      window.dataLayer.push(
          Object.assign(
              {
                event: 'page_view'
              },
              {
                  virtual_page: window.location.href
              }
          )
      );
  }, 1500);
};

module.exports = { runConsentEvent };